export default __webpack_public_path__ + "static/desktop-video-icon-c995de3ae6b0ba8adf422eac39f23e89.png";